// client/src/utils/callVisibility.js
//
// Mirrors backend/utils/callVisibility.js. The backend decides what each person
// receives; the frontend only needs to know which layout to show.
//   receptionist — every inbound call ("All Calls" board)
//   manager      — their 3CX ring groups' calls ("Department Calls" board)
//   user         — their own calls only (the existing Live Calls feed)

const RANK = { user: 0, manager: 1, receptionist: 2 };

export function visibilityFromRoleName(roleName) {
  const r = String(roleName || '').toLowerCase();
  if (!r) return 'user';
  if (r.includes('recept')) return 'receptionist';
  if (r.includes('system') || r.includes('sysadmin') || r === 'admin' || r === 'admins') return 'receptionist';
  if (r.includes('manager') || r.includes('owner') || r.includes('supervisor')) return 'manager';
  return 'user';
}

/** Visibility for the signed-in user (new logins carry roleDetails.visibility). */
export function getVisibility(currentUser) {
  const stored = currentUser?.roleDetails?.visibility;
  if (stored && RANK[stored] !== undefined) return stored;
  return visibilityFromRoleName(currentUser?.role);
}

export const receivesBoard = (visibility) => visibility === 'receptionist' || visibility === 'manager';

/** Ended calls stay on the board for the last 60 minutes, greyed out. */
export const isBoardCallEnded = (call) => !!call?.endedAt || call?.status === 'Ended' || call?.status === 'Missed';

/** Live calls first, then the last hour's ended calls; newest first in each. */
export function orderBoardCalls(calls = []) {
  const newest = (a, b) => (b.firstSeen || 0) - (a.firstSeen || 0);
  const live = calls.filter((c) => !isBoardCallEnded(c)).sort(newest);
  const ended = calls.filter(isBoardCallEnded).sort(newest);
  return [...live, ...ended];
}

export const boardTitle = (visibility) => (visibility === 'receptionist' ? 'All Calls' : 'Department Calls');

/**
 * Can a board call be transferred/ended right now? Answered calls yes; a direct
 * (non-ring-group) call ringing a single phone yes; a ring-group call that is
 * still ringing no — the backend refuses it too (nothing to move yet).
 */
export function boardCallActionable(call) {
  if (!call || isBoardCallEnded(call)) return false;
  if (call.status && call.status !== 'Ringing') return true;
  const ringing = (call.legs || []).filter((l) => l.status === 'Ringing');
  return (call.ringGroups || []).length === 0 && ringing.length === 1;
}
